import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('guide-board', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48"
  }, [_createVNode("g", {
    "stroke": "none",
    "stroke-width": props.strokeWidth,
    "fill": "none",
    "fill-rule": "evenodd",
    "stroke-linejoin": props.strokeLinejoin
  }, [_createVNode("g", {
    "transform": "translate(6.000000, 4.000000)",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, [_createVNode("path", {
    "d": "M18,0 L18,37",
    "stroke-linecap": props.strokeLinecap
  }, null), _createVNode("polygon", {
    "fill": props.colors[1],
    "fill-rule": "nonzero",
    "points": "18 4 33.5454545 4 36 8 33.5454545 12 18 12"
  }, null), _createVNode("polygon", {
    "fill": props.colors[1],
    "fill-rule": "nonzero",
    "transform": "translate(9.000000, 22.000000) scale(-1, 1) translate(-9.000000, -22.000000) ",
    "points": "0 18 15.5454545 18 18 22 15.5454545 26 0 26"
  }, null), _createVNode("path", {
    "d": "M10,38 L26,38",
    "stroke-linecap": props.strokeLinecap
  }, null)])])]);
});